import { compose, graphql } from "react-apollo";
import { AllTasks } from "../../queries/AllTasks";
import { CurrentUser } from "../../queries/CurrentUser";
import { paginationVariables, withPagination } from "../../utils/pagination";

export const initialFilters = {
  claimStatuses: [],
  taskTypes: [],
  taskStatuses: [],
  taskPriorities: [],
  passengerFullNames: [],
  claimIds: [],
  passengerEmails: [],
};

const withUserTasksQuery = WrappedComponent =>
  compose(
    withPagination(initialFilters),
    graphql(CurrentUser, {
      options: () => ({ fetchPolicy: "cache-first" }),
      props: ({ data: { loading, error, viewer, variables }, ownProps: { filter } }) => ({
        error,
        loading,
        viewerId: viewer && viewer.id,
        variables,
        filter,
      }),
    }),
    graphql(AllTasks, {
      skip: ({ viewerId }) => !viewerId,
      options: ({ filter, viewerId, ...rest }) => ({
        variables: {
          filter: { ...filter, assigneeIds: [viewerId] },
          ...paginationVariables(rest),
        },
        notifyOnNetworkStatusChange: true,
      }),
      props: ({
        data: { tasksConnection, variables, loading: loadingTasks, error },
        ownProps: { filter, loading },
      }) => ({
        error,
        loading: loadingTasks || loading,
        tasksConnection,
        variables: variables || {},
        filter,
      }),
    })
  )(WrappedComponent);

export default withUserTasksQuery;



// WEBPACK FOOTER //
// ./src/component/TasksList/withUserTasksQuery.js